import { useCallback } from 'react'
import * as d3 from 'd3'

import {
  DEFAULT_QUARK,
  DONE_QUARK,
  FULFILL_QUARK,
  ANIMATION_DELAY
} from '@aytm/app/stats/page/data-centrifuge/lib/utils'
import { getRectPath } from '@aytm/app/stats/page/data-centrifuge/lib/d3-helpers'

// SVG path data for loader graphics
const LOADER_PATHS = {
  background:
    'M89.6,63.6c0,3.9-3.1,7-7,7 c-0.5,0-1-0.1-1.6-0.2c-2.7,3.5-5.9,6.5-9.7,8.8c-0.9,0.6-1.5,1.6-1.4,2.7c0.2,4.6-3.3,8.6-8,8.9c-3.4,0.2-6.5-1.7-8-4.7 c-0.4-0.7-1.1-1.2-1.9-1.2l0,0c-20.2,0-36.6-16.3-36.6-36.5c0,0,0,0,0,0c0-1,0-2,0.1-2.9c0.1-1.2-0.5-2.3-1.6-2.9 c-4.7-2.6-6.4-8.5-3.7-13.2c1.7-3.1,5-5,8.5-5l0,0c0.7,0,1.2-0.5,1.2-1.2c0-0.1,0-0.1,0-0.1c-0.1-0.7-0.1-1.5,0-2.2 c0.5-3.5,3.4-6.1,6.9-6.5c1.7-0.2,3.3,0.2,4.7,1.1c1.3,0.8,2.8,0.9,4.2,0.2c12.4-6.2,27.3-4.8,38.3,3.6c1.7,1.3,3.9,1.6,5.9,1 c4.8-1.5,9.9,1.2,11.4,6.1c1,3.4,0,7.1-2.6,9.5c-1.1,1-1.5,2.5-1.2,3.9c1.3,5.2,1.4,10.7,0.3,16c-0.3,1.5,0,3.1,0.8,4.5 C89.2,61.1,89.5,62.3,89.6,63.6z',
  outer:
    'M89.6,63.6c0,3.9-3.1,7-7,7 c-0.5,0-1-0.1-1.6-0.2c-2.7,3.5-5.9,6.5-9.7,8.8c-0.9,0.6-1.5,1.6-1.4,2.7c0.2,4.6-3.3,8.6-8,8.9c-3.4,0.2-6.5-1.7-8-4.7 c-0.4-0.7-1.1-1.2-1.9-1.2l0,0c-20.2,0-36.6-16.3-36.6-36.5c0,0,0,0,0,0c0-1,0-2,0.1-2.9c0.1-1.2-0.5-2.3-1.6-2.9 c-4.7-2.6-6.4-8.5-3.7-13.2c1.7-3.1,5-5,8.5-5l0,0c0.7,0,1.2-0.5,1.2-1.2c0-0.1,0-0.1,0-0.1c-0.1-0.7-0.1-1.5,0-2.2 c0.5-3.5,3.4-6.1,6.9-6.5c1.7-0.2,3.3,0.2,4.7,1.1c1.3,0.8,2.8,0.9,4.2,0.2c12.4-6.2,27.3-4.8,38.3,3.6c1.7,1.3,3.9,1.6,5.9,1 c4.8-1.5,9.9,1.2,11.4,6.1c1,3.4,0,7.1-2.6,9.5c-1.1,1-1.5,2.5-1.2,3.9c1.3,5.2,1.4,10.7,0.3,16c-0.3,1.5,0,3.1,0.8,4.5 C89.2,61.1,89.5,62.3,89.6,63.6z M23.6,34.4c0.3-2.6-1.6-5-4.3-5.2c-2.6-0.3-5,1.6-5.2,4.3c-0.3,2.6,1.6,5,4.3,5.2c0.3,0,0.6,0,1,0 C21.5,38.4,23.3,36.6,23.6,34.4L23.6,34.4z M24.9,21.5c-0.2,1.5,0.9,2.9,2.4,3.1c1.5,0.2,2.9-0.9,3.1-2.4c0.2-1.5-0.9-2.9-2.4-3.1 c-0.2,0-0.5,0-0.7,0C26,19.3,25,20.2,24.9,21.5L24.9,21.5z M65,82.7c0.3-1.9-1.1-3.7-3-3.9s-3.7,1.1-3.9,3s1.1,3.7,3,3.9 c0.3,0,0.6,0,0.9,0C63.6,85.5,64.8,84.3,65,82.7z M78.4,48.4c0.1-14.6-11.6-26.5-26.2-26.6S25.7,33.4,25.6,48s11.6,26.5,26.2,26.6 c0.1,0,0.3,0,0.4,0C66.6,74.5,78.2,62.8,78.4,48.4L78.4,48.4z M84.6,63.9c0.2-1.1-0.6-2.2-1.7-2.4c-1.1-0.2-2.2,0.6-2.4,1.7 s0.6,2.2,1.7,2.4c0.2,0,0.5,0,0.7,0C83.8,65.5,84.4,64.8,84.6,63.9L84.6,63.9z M86.8,28.8c0-2.3-1.9-4.2-4.2-4.2 c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2l0,0C84.9,32.9,86.8,31.1,86.8,28.8L86.8,28.8z',
  inner:
    'M58.6,57.4c0.1,1.1-0.1,2.1-0.8,3l0,0c-1.4,1.8-3.9,2.2-5.7,0.8s-2.2-3.9-0.8-5.7s3.9-2.2,5.7-0.8 C57.9,55.3,58.4,56.3,58.6,57.4z M67.3,45.9c-2.2-2.3-5.8-2.4-8.1-0.2c-2.3,2.2-2.4,5.8-0.2,8.1s5.8,2.4,8.1,0.2 c0.2-0.2,0.4-0.5,0.6-0.7l0,0c1.1-1.4,1.4-3.3,0.9-5C68.4,47.4,68,46.6,67.3,45.9z M54.7,50c3.2-4.3,2.3-10.5-2-13.7 s-10.5-2.3-13.7,2c-3.2,4.3-2.3,10.5,2,13.7c0,0,0,0,0,0C45.3,55.2,51.5,54.3,54.7,50z',
  spin: 'M52,28.1l0.2,0c10.7,0.1,19.4,8.5,19.9,19l0,1.2C72,59.3,63,68.2,52.2,68.3l-0.1,0l-0.2,0c-11.1-0.1-20-9.2-19.9-20.3 C32,37,41,28.1,52,28.1 M52,23.1c-13.8,0-25,11.1-25.1,24.9c-0.1,13.9,11,25.2,24.9,25.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0 C65.9,73.2,77,62.1,77.1,48.4h0c0.1-13.9-11-25.2-24.9-25.3C52.2,23.1,52.1,23.1,52,23.1L52,23.1z'
}

/**
 * Initialize the loader group elements in SVG
 */
export const initLoaderGroup = (svg, center) => {
  const loader = svg
    .append('g')
    .attr('class', 'group-loader')
    .attr('data-testid', 'stat-dc-loader')
    .attr('transform', `translate(${center.x - 92.835},${center.y - 89.475}) scale(1.76)`)
    .style('pointer-events', 'none')
    .style('opacity', 0)

  const defs = loader.append('defs')
  defs
    .append('linearGradient')
    .attr('id', 'dc-loader-gradient')
    .append('stop')
    .attr('stop-color', '#b8e6da')
    .attr('stop-opacity', 1)
    .attr('offset', '0')
    .select(function () {
      return this.parentNode
    })
    .append('stop')
    .attr('stop-color', '#73b0ac')
    .attr('stop-opacity', 1)
    .attr('offset', '1')

  loader.append('path').attr('d', LOADER_PATHS.background).attr('fill', '#ffffff')

  loader.append('path').attr('class', 'group-loader-outer').attr('d', LOADER_PATHS.outer).attr('fill', '#aeaeae')

  loader.append('path').attr('class', 'group-loader-inner').attr('d', LOADER_PATHS.inner).attr('fill', '#aeaeae')

  loader
    .append('path')
    .attr('class', 'group-loader-spin')
    .attr('transform', 'rotate(0,51.958,48.188)')
    .attr('d', LOADER_PATHS.spin)
    .attr('fill', '#aeaeae')

  return loader
}

/**
 * Initialize the progress group elements in SVG
 */
export const initProgressGroup = (svg, center) => {
  const progress = svg
    .append('g')
    .attr('class', 'group-progress')
    .attr('transform', `translate(${center.x},${center.y + 60})`)
    .style('pointer-events', 'none')
    .style('opacity', 0)

  const defs = progress.append('defs')
  defs
    .append('filter')
    .attr('id', 'dc-progress-shadow')
    .append('feDropShadow')
    .attr('dx', 0)
    .attr('dy', 0)
    .attr('stdDeviation', 3.5)
    .attr('flood-color', '#00000050')

  defs
    .append('clipPath')
    .attr('id', 'dc-progress-mask')
    .append('path')
    .attr('d', getRectPath(36, 46, 264, 10, 0, 6, 6, 0))

  const progressG = progress
    .append('g')
    .attr('transform', 'translate(-168,0)')
    .style('filter', 'url(#dc-progress-shadow)')

  progressG
    .append('rect')
    .attr('x', 36)
    .attr('y', 46)
    .attr('width', 264)
    .attr('height', 10)
    .attr('fill', '#b8e6da')
    .attr('stroke', '#b8e6da')
    .attr('stroke-width', 0)
    .attr('clip-path', 'url(#dc-progress-mask)')

  progressG
    .append('rect')
    .attr('class', 'group-progress-fill')
    .attr('data-testid', 'stat-dc-progress-bar')
    .attr('x', 36)
    .attr('y', 46)
    .attr('width', 0)
    .attr('height', 10)
    .attr('fill', '#73b0ac')
    .attr('stroke', '#73b0ac')
    .attr('stroke-width', 0)
    .attr('clip-path', 'url(#dc-progress-mask)')

  progressG
    .append('path')
    .attr('d', getRectPath(0, 0, 336, 46, 23, 23, 23, 23))
    .attr('fill', '#ffffff')
    .attr('stroke', '#00000029')
    .attr('stroke-width', 0)

  progress
    .append('g')
    .attr('transform', 'translate(0,30)')
    .append('text')
    .attr('class', 'group-progress-text')
    .attr('data-testid', 'stat-dc-progress-text')
    .text('')
    .attr('fill', '#444444')
    .style('font-size', '15px')
    .style('line-height', '17px')
    .style('font-family', 'Ubuntu, Calibri, Segoe, Helvetica, Arial')
    .style('text-anchor', 'middle')

  return progress
}

/**
 * Initialize the info group elements in SVG
 */
export const initInfoGroup = (svg, chartHeight) => {
  const info = svg
    .append('g')
    .attr('class', 'group-info')
    .attr('transform', `translate(10,${chartHeight - 10})`)

  info
    .append('text')
    .attr('class', 'group-info-text')
    .attr('data-testid', 'stat-dc-info')
    .text('')
    .attr('fill', '#444444')
    .style('font-size', '14px')
    .style('line-height', '16px')
    .style('font-style', 'italic')
    .style('font-family', 'Ubuntu, Calibri, Segoe, Helvetica, Arial')
    .style('text-anchor', 'start')

  return info
}

/**
 * Custom hook for loader rendering logic
 */
export const useLoader = ({ svgRef, jobRef, data, job, chartHeight, onCallback }) => {
  // `job` is the phase-only memo (stable across progress ticks) and
  // drives `renderLoader`'s recomputation: only status / per-vector
  // running/done changes re-register the transitions. Live progress numbers
  // (`job.progress.current`, `job.progress.vector.current`, `job.progress.real`)
  // come from `jobRef.current` and are read fresh inside the
  // attrTween on every animation frame. Fixes BUG-D: renderLoader was
  // previously re-fired every onCallback tick, which interrupted and
  // restarted the spin + progress-fill tweens every frame.
  const renderLoader = useCallback(() => {
    if (!svgRef.current || !data || !job) return

    const svg = svgRef.current

    const vectorKeys = Object.keys(job.vectors || {})
    const error = job.status == 'error' || (vectorKeys.length > 0 && vectorKeys.every(id => job.vectors[id] == 'idle'))

    // DC-v3: vectors run in parallel, so we no longer expose a per-vector
    // running color/name. The loader is always grey + the generic progress label;
    // see specs/.../dc-v3 chart.coffee renderLoader.
    const outerColor = '#aeaeae'
    const innerColor = error || ['waiting', 'error'].includes(job.status) ? '#aeaeae' : '#88d1cd'
    const spinColor = error || ['waiting', 'error'].includes(job.status) ? '#aeaeae' : 'url(#dc-loader-gradient)'

    const progressText = 'Spinning up Data Centrifuge'

    // Info group
    let info = svg.selectAll('.group-info')
    if (info.empty()) {
      info = initInfoGroup(svg, chartHeight)
    }

    // Loader group
    let loader = svg.selectAll('.group-loader')
    if (loader.empty()) {
      loader = initLoaderGroup(svg, data.center)
    }

    // Progress group
    let progress = svg.selectAll('.group-progress')
    if (progress.empty()) {
      progress = initProgressGroup(svg, data.center)
    }

    // Interrupt any running animations
    loader.interrupt()
    loader.selectAll('.group-loader-spin').interrupt()
    progress.interrupt()
    progress.selectAll('.group-progress-fill').interrupt()

    // Update colors
    loader.selectAll('.group-loader-outer').attr('fill', outerColor)
    loader.selectAll('.group-loader-inner').attr('fill', innerColor)
    loader.selectAll('.group-loader-spin').attr('fill', spinColor)

    switch (job.status) {
      // Handle waiting/running state
      case 'waiting':
      case 'running': {
        info
          .selectAll('.group-info-text')
          .text(job.status == 'running' ? "Feel free to close this page, it won't stop the Centrifuge" : '')

        loader
          .transition()
          .ease(d3.easeQuad)
          .duration(DEFAULT_QUARK / 2)
          .attr('transform', `translate(${data.center.x - 92.835},${data.center.y - 109.475}) scale(1.76)`)
          .style('opacity', 1)

        progress
          .transition()
          .ease(d3.easeQuad)
          .duration(DEFAULT_QUARK / 2)
          .style('opacity', 1)

        progress.selectAll('.group-progress-text').text(`${progressText} - ${job.progress?.current}%`)
        progress.selectAll('.group-progress-fill').attr('width', 2.64 * job.progress?.current)

        // Animation loop for running state
        if (job.status == 'running') {
          const jobProgress = structuredClone(job.progress)

          const deviation = (current, real) => {
            let res = 3
            if (real == 0) res = 5
            if (current == real) res = 4
            if (current < real) res = 1
            if (current > real) res = Math.max(res, current - real)
            return res
          }

          const repeat = () => {
            loader
              .selectAll('.group-loader-spin')
              .transition()
              .ease(d3.easeQuad)
              .duration(ANIMATION_DELAY)
              .attrTween('transform', () => t => `rotate(${360 * t},51.958,48.188)`)
              .on('end', repeat)

            progress
              .selectAll('.group-progress-fill')
              .transition()
              .ease(d3.easeQuad)
              .duration(ANIMATION_DELAY)
              .attrTween('width', function () {
                const p = Math.round(d3.select(this).node().getBBox().width / 2.64)

                // Read live progress from jobRef, not the phase-stable
                // `job` closure, so we always chase the most recent
                // server-reported percent without re-registering the tween.
                const live = jobRef?.current || job
                const currentDeviation = deviation(live.progress.current, live.progress.real)

                return t => {
                  const liveT = jobRef?.current || job
                  jobProgress.current = Math.min(
                    100,
                    p + Math.round(((liveT.progress.current - p + 3) * t) / currentDeviation)
                  )

                  if (typeof onCallback == 'function') {
                    onCallback({ progress: jobProgress })
                  }

                  progress.selectAll('.group-progress-text').text(`${progressText} - ${jobProgress.current}%`)
                  return 2.64 * jobProgress.current
                }
              })
          }
          repeat()
        }

        break
      }

      // Handle fulfill state
      case 'fulfill': {
        info.selectAll('.group-info-text').text('')

        loader
          .selectAll('.group-loader-spin')
          .attr('transform', 'rotate(0,51.958,48.188)')
          .transition()
          .ease(d3.easeQuad)
          .duration(FULFILL_QUARK)
          .attrTween('transform', () => t => `rotate(${30 * t},51.958,48.188)`)

        progress.selectAll('.group-progress-text').text(`${progressText} - ${job.progress?.current}%`)
        progress.selectAll('.group-progress-fill').attr('width', 2.64 * job.progress?.current)

        break
      }

      // Handle done state
      case 'done': {
        info.selectAll('.group-info-text').text('')

        loader
          .selectAll('.group-loader-spin')
          .attr('transform', 'rotate(0,51.958,48.188)')
          .transition()
          .ease(d3.easeQuad)
          .duration(DONE_QUARK)
          .attrTween('transform', () => t => `rotate(${180 * t},51.958,48.188)`)

        progress
          .selectAll('.group-progress-fill')
          .transition()
          .ease(d3.easeQuad)
          .duration(DONE_QUARK)
          .attrTween('width', function () {
            const p = Math.round(d3.select(this).node().getBBox().width / 2.64)
            return t => {
              const current = p + Math.round((100 - p) * t)
              progress.selectAll('.group-progress-text').text(`${progressText} - ${current}%`)
              return 2.64 * current
            }
          })

        break
      }

      // Handle completed state
      case 'completed': {
        info.selectAll('.group-info-text').text('')

        loader
          .transition()
          .ease(d3.easeQuad)
          .duration(DEFAULT_QUARK / 2)
          .attr('transform', `translate(${data.center.x - 92.835},${data.center.y - 89.475}) scale(1.76)`)
          .style('opacity', 0)

        progress
          .transition()
          .ease(d3.easeQuad)
          .duration(DEFAULT_QUARK / 2)
          .style('opacity', 0)

        break
      }

      default: {
        info.selectAll('.group-info-text').text('')

        loader
          .transition()
          .ease(d3.easeQuad)
          .duration(DEFAULT_QUARK / 2)
          .attr('transform', `translate(${data.center.x - 92.835},${data.center.y - 89.475}) scale(1.76)`)
          .style('opacity', error ? 1 : 0)

        progress
          .transition()
          .ease(d3.easeQuad)
          .duration(DEFAULT_QUARK / 2)
          .style('opacity', 0)
      }
    }
    // `jobRef` is a stable React ref; included in deps for completeness
    // but never changes identity. `job` is the phase-stable memo from
    // the parent (layoutComponents), so this callback re-creates only on
    // phase changes, not progress ticks.
  }, [svgRef, jobRef, data, job, chartHeight, onCallback])

  return { renderLoader }
}

export default useLoader
